// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge_badge__DWnPS","grey":"badge_grey__v1C7G","red":"badge_red__I1KyY","purple":"badge_purple__le8Ay","green":"badge_green__9UL6D","yellow":"badge_yellow__PC5wU"};